module.exports = __webpack_public_path__ + "img/secretswap_logo_hover.069a815e.png";